import { DateTime } from 'luxon'
import { getAppPreferences } from '../globals'

const isValidTimezone = (timeZone: string): boolean => {
  try {
    return DateTime.local().setZone(timeZone).isValid
  } catch {
    return false
  }
}

const getBrowserTimezone = (): string => {
  try {
    const browserTz =
      Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'Etc/UTC'
    if (browserTz && isValidTimezone(browserTz)) {
      return browserTz
    }
    console.warn(
      `Invalid browser timezone detected: "${browserTz}". Falling back to UTC.`,
    )
    return 'UTC'
  } catch (error) {
    console.warn(
      'Error detecting browser timezone, falling back to UTC:',
      error,
    )
    return 'UTC'
  }
}

const BROWSER_TIMEZONE = getBrowserTimezone()

/**
 * Gets the default timezone from app preferences or browser, with validation.
 * Returns a validated timezone string (guaranteed to be valid).
 *
 * @returns A valid IANA timezone identifier (defaults to UTC if all sources are invalid)
 */
export const getDefaultTimezone = (): string => {
  const appPreferences = getAppPreferences()
  const preferenceTimezone = appPreferences?.defaultRegion?.Timezone

  if (preferenceTimezone) {
    if (isValidTimezone(preferenceTimezone)) {
      return preferenceTimezone
    }
    console.warn(
      `Invalid timezone in app preferences (defaultRegion.Timezone): "${preferenceTimezone}". ` +
        `Falling back to browser timezone.`,
    )
  }

  return BROWSER_TIMEZONE
}
